import React,{Component} from 'react';

import './Login.css';
import { connect } from 'react-redux';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { homeBanner } from '../../theme/images';
import Message from '@acri-tools/react-tools/components/Message/Message';
import { go_back, pushHistory, push_history } from '@acri-tools/react-tools/utils/global';
import { store_user } from '@acri-tools/react-tools/utils/_user_manager/login';
import axios from 'axios';
import { API_URL, get_page_title } from '../../utils/config';
import { DEV_MODE } from '../../utils/globa';
import { Helmet } from 'react-helmet';
import Loading from '@acri-tools/react-tools/components/Loading/Loading';
import classNames from 'classnames';

interface Props{
}
interface State{
    email: string
    password: string
    loggingIn: boolean
    hasEntered: boolean
    message: string
    messageType: string
}

class Login extends Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state={
            email:'',
            password:'',
            loggingIn:false,
            hasEntered:false,
            message: '',
            messageType: 'error'
        }
    }
    render(){
        return (
            <Page 
                id="login"
                topBar
            >
                <Helmet>
                    <title>{ get_page_title('DAMPS - Login') }</title>
                    <meta 
                        name="description" 
                        content="Login to the DAMPS platform and start using the services"
                    />
                </Helmet>
                <div 
                    className="page-content"
                    style={{
                        backgroundImage:`url(${homeBanner})`
                    }}
                >
                    <div id="login-container" className="form-container">
                        {
                            DEV_MODE && 
                            <>
                                <div className="form">
                                    <div className="form-field large">
                                        <label>
                                            Email - Username
                                        </label>
                                        <input 
                                            type="email" value={this.state.email} placeholder={"Email - Username"}
                                            onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({email:e.target.value}); }}/>
                                    </div>
                                    <div className="form-field large">
                                        <label>
                                            Password
                                        </label>
                                        <input 
                                            type="password" value={this.state.password}  placeholder={"Password"}
                                            onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({password:e.target.value}); }}/>
                                    </div>
                                    
                                    <Message message={ this.state.message } type={ this.state.messageType }/>
                                    
                                </div>
                                
                                <br/>
                                <div 
                                    className={classNames({
                                        "custom-button login themed inverted shadow rounded": true,
                                        "disabled": this.state.loggingIn
                                    })}
                                    onClick={this.login}
                                >
                                    {
                                        this.state.loggingIn ? 
                                            <Loading spinnerProps={{ height: 12, white:true }} message="LOGGING IN..."/>
                                        :
                                            "LOGIN"
                                    }
                                </div>
                            </>
                        }
                        

                        {/* TEMP */}
                        <h2 className="divider"><div className="line"/><span>PROVIDERS</span><div className="line"/></h2>
                        <a 
                            className="custom-button keycloak inverted shadow rounded" 
                            href={`${API_URL}/api/v1/auth/keycloak`}
                        >
                            DAMPS Single Sign-On
                        </a>
                    </div>  
                </div>
            </Page>
        );
    }

    inputTyped = () =>{
        this.setState({
            message: ''
        })
    }
    onEnter = (e:any) =>{
        if(e.keyCode === 13){
            this.login();
        }
    }
    login = async() =>{
        if(!this.state.email){
            this.setState({
                message: 'Missing Username or Email',
                messageType: 'warn'
            })
        }
        else if(!this.state.password){
            this.setState({
                message: 'Missing Password',
                messageType: 'warn'
            })
        }
        else{
            this.setState({ loggingIn:true });
            try{
                let user = await this.login_provider('keycloak');
                // console.log("user", user);
                await store_user(user);
                // go_back();
                pushHistory('/')
            }
            catch(e:any){
                this.setState({
                    message: e?.response?.data?.details?.message || 'An error has occured during login. Please try again later.',
                    messageType: 'error'
                })
            }
            finally{
                this.setState({ loggingIn:false });
            }
        }
    }

    login_provider = async(provider:string) =>{
        let res = await axios.get(`${API_URL}/api/user-manager/v1/login`,{
            params:{
                provider, 
                session: true,
            },
            headers:{
                Authorization: `Basic ${Buffer.from(this.state.email + ":" + this.state.password).toString('base64')}`
            }
        });
        return res.data;
    }

    login_keycloak = async() =>{
        this.setState({ loggingIn:true });
        try{
            let res = await axios.get(`${API_URL}/api/v1/auth/keycloak`,{
                headers: {
                    "Access-Control-Allow-Origin": "http://keycloak:8080"
                }
            });
            let user = res.data;
            // console.log("user", user);
            // await store_user(user);
            // go_back();
        }
        catch(e:any){
            this.setState({
                message: e?.response?.data?.details?.message || 'An error has occured during login. Please try again later.',
                messageType: 'error'
            })
        }
        finally{
            this.setState({ loggingIn:false });
        }
    }
};

export default connect((state:any) =>{
    return {
        login : state.login
    }
})(Login);
